<template>
  <CModal
    title="แก้ไขหมวดหมู่หนังสือ"
    :show.sync="isShow"
    :closeOnBackdrop="false"
    @update:show="closeModal"
    centered
  >
    <CRow>
      <CCol sm="12">
        <CInput label="ชื่อหมวดหมู่ (ภาษาไทย) **" v-model="info.nameTH" />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput label="ชื่อหมวดหมู่ (ภาษาอังกฤษ)" v-model="info.nameEN" />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput label="ชื่อหมวดหมู่ (ภาษาภูฏาน)" v-model="info.nameDZ" />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <label for="sound-file">ภาพหมวดหมู่</label>
        <CInputFile @change="imageChange" :value="null" />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12">
        <label for="sound-file">ภาพปกหนังสือ</label>
        <CInputFile @change="bookChange" :value="null" />
      </CCol>
    </CRow>

    <CRow v-if="errorMessage">
      <CCol sm="12" class="text-danger text-center">
        <span v-html="errorMessage"></span>
      </CCol>
    </CRow>

    <template slot="footer">
      <CButton color="dark" variant="outline" @click="cancle">
        ยกเลิก
      </CButton>
      <CButton color="success" @click="confirm">
        บันทึก
      </CButton>
    </template>
  </CModal>
</template>

<script>
import apiBookCategory from '@/apis/book_category'
import apiUpload from '@/apis/upload'

export default {
  name: 'BookCategoryEditModal',
  props: {
    onComplete: Function
  },
  data() {
    return {
      info: {
        id: '',
        nameTH: '',
        nameEN: '',
        nameDZ: '',
        image: null,
        bookImage: null
      },
      uploadImage: null,
      uploadBookImage: null,
      isShow: false,
      errorMessage: ''
    }
  },
  methods: {
    show(info) {
      this.isShow = true
      this.errorMessage = ''
      this.info = { ...info }
      this.uploadImage = null
      this.uploadBookImage = null
    },
    clear() {
      setTimeout(() => {
        this.info = {}
      }, 500)
    },
    cancle() {
      this.isShow = false
      this.clear()
    },
    imageChange(files) {
      this.uploadImage = files[0]
    },
    bookChange(files) {
      this.uploadBookImage = files[0]
    },
    async confirm() {
      if (!this.info.name) {
        this.errorMessage = 'ต้องกรอก <b>ชื่อหมวดหมู่ (ภาษาไทย)</b>'
        return
      }
      try {
        if (this.uploadImage) {
          const response = await apiUpload.uploadImage(this.uploadImage)
          this.info.image = response.data[0].name
        } else {
          this.info.image = this.getNameFromPath(this.info.image)
        }

        if (this.uploadBookImage) {
          const response = await apiUpload.uploadImage(this.uploadBookImage)
          this.info.bookImage = response.data[0].name
        } else {
          this.info.bookImage = this.getNameFromPath(this.info.bookImage)
        }

        this.info.name = this.info.nameTH

        apiBookCategory.update(this.info).then(() => {
          this.onComplete()
        })

        this.isShow = false
        this.clear()
      } catch {}
    },
    getNameFromPath(path) {
      return path.substr(path.lastIndexOf('/') + 1)
    },
    closeModal() {
      this.clear()
    }
  }
}
</script>
